<div class="card border-0 rounded-5 shadow-sm mb-3" data-bs-toggle="modal" data-bs-target="#document_approval_modal">
  <div class="card-body p-3">
      <!-- Profile Section -->
      <div class="d-flex align-items-center">
          <div class="input-container flex-grow-1">
              <input type="text text-xxs" 
                     class="form-control bg-light border-0" 
                     placeholder="Get your document approved ..."
                     aria-label="Post content">
          </div>
          <div>
            <i class="bi bi-filetype-docx fs-6 text-primary"></i>
          </div>
      </div>
  </div>
</div>
<div class="modal fade" id="document_approval_modal" tabindex="-1" aria-labelledby="documentApprovalModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500" id="documentApprovalModalLabel">Document Approval</p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="createDocumentApproval">
          <div class="modal-body modal-body-scroll">
  
            <!-- Document Name -->
            <div class="mb-3">
              <label for="document_name" class="form-label text-xs fw-500">Document Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xs" id="document_name" placeholder="Enter document name" v-model="document_name">
              <p v-if="errors.document_name" class="text-danger text-xs">{{ errors.document_name }}</p>
            </div>
  
            <!-- Select Reviewer -->
            <div class="d-flex flex-row justify-content-between mx-1">
              <div class="mb-3">
                <label for="reviewer" class="form-label text-xs fw-500">
                  <span class="text-danger">*</span> Assign reviewers:
                </label>
  
                <multiselect
                  v-model="tempSelectedReviewer"
                  :options="reviewers"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="* Reviewers"
                  label="first_name"
                  track-by="id"
                  class="text-xs fw-500 mb-3"
                >
                  <template #option="{ option }">
                    {{ option.first_name }} {{ option.last_name }}
                  </template>
                  <template #selection="{ values }">
                    <span
                      v-for="(reviewer, index) in values"
                      :key="index"
                      class="badge bg-primary me-1"
                    >
                      {{ reviewer.first_name }} {{ reviewer.last_name }}
                    </span>
                  </template>
                </multiselect>
  
                <p v-if="errors.reviewer" class="text-danger text-xs">{{ errors.reviewer }}</p>
              </div>
            </div>
  
           <!-- Document Review Section (Editor or Description) -->
           <QuillEditor theme="snow" v-model="document_description" ref="quillDocumentEditorRef" class="quill-editor"
           placeholder="Enter your description here..." toolbar="full" />
  
            <!-- File Upload for Document -->
            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start border-bottom">
              <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
                <label for="approvalFileInput" class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                  <i class='bx bx-image-add file-upload-icon'></i> Upload Document/Media
                </label>
                <input type="file" id="approvalFileInput" class="file-input d-none" @change="handleApprovalFileUpload" />
                <div v-if="fileName" class="text-xs text-secondary fst-italic mt-1">
                  <span class="fw-500">File name:</span> {{ fileName }}
                </div>
                <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>
  
                <!-- Image or Document Preview -->
                <div v-if="filePreview" class="mt-2">
                  <a :href="filePreview" target="_blank" class="text-xs text-primary">Preview Document</a>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-5">Submit for Approval</button>
          </div>
        </form>
      </div>
    </div>
  </div>